import { useCallback } from 'react';

import { useMutation } from '@apollo/client/react';

import { AiAutoReplyConfigFormData } from '@anyx/function-chat/shared';
import { toast } from '@anyx/shared-ui';

import { UPDATE_AI_AUTO_REPLY_SETTING, GET_STORE_AI_AUTO_REPLY_SETTING } from '../graphql';

export const useUpdateAIAutoReplySetting = () => {
  const [updateAIAutoReplySettingMutation, { loading }] = useMutation(UPDATE_AI_AUTO_REPLY_SETTING);

  const updateAIAutoReplySetting = useCallback(
    async ({
      enabled,
      storeId,
      chatType,
      contextId,
      hasAiFooter = false,
    }: AiAutoReplyConfigFormData) => {
      try {
        const success = await updateAIAutoReplySettingMutation({
          variables: {
            input: {
              storeId,
              messagingChannel: chatType,
              systemInstructionId: enabled ? contextId : null,
              hasAiFooter,
            },
          },
          update: (cache, { data }) => {
            if (data?.updateAIAutoReplySetting?.ok) {
              cache.writeQuery({
                query: GET_STORE_AI_AUTO_REPLY_SETTING,
                variables: {
                  input: {
                    storeId,
                    channel: chatType,
                  },
                },
                data: {
                  getStoreSetting: {
                    __typename: 'AIAutoReplyStoreSetting',
                    contextConfigId: enabled ? contextId : null,
                    hasAiFooter,
                  },
                },
              });
            }
          },
        });

        toast.success();

        return success;
      } catch (error) {
        toast.error();

        return false;
      }
    },
    [updateAIAutoReplySettingMutation]
  );

  return {
    updateAIAutoReplySetting,
    loading,
  };
};
